import { rejoinCardImages as e } from "../properties/rejoinCardImages.mjs";
import { recentlyViewedQueryKeys as t } from "./useRecentlyViewedQueryKeys.mjs";
import { useQuery as n } from "@maat/store-hooks";
import { recentlyViewedApi as r } from "@maat/api-main";
import { useIsAuthenticated as i } from "@maat/store-auth";
//#region src/recentlyViewed/useRecentlyViewedListingsQuery.ts
var a = (t) => ({
	...t,
	items: t.items.map((n) => e(n, t.imageBase))
}), o = (e) => {
	let o = i();
	return n({
		queryKey: t.list(e),
		queryFn: () => r.list(e ? { limit: e } : void 0),
		enabled: o,
		staleTime: 6e4,
		select: a
	});
};
//#endregion
export { o as useRecentlyViewedListingsQuery };
